//component entry file
import Portfolio from "./components/main/Index.vue";

export default Portfolio;